/**
 * Shared drag contract for "mover conversa para pasta" (M8/AC6).
 *
 * Espelha `modules/tarefas/utils/taskMoveDrag.js`: a linha de conversa
 * (drag-start) escreve um payload comum no `dataTransfer`; a linha de pasta
 * (drop-target) o lê no `@drop`. Centralizar a chave MIME + (de)serialização
 * aqui evita divergência entre as superfícies (popup e página cheia) e faz toda
 * movimentação passar por `apiFolders.moveConversation`.
 *
 * Payload shape: { conversationId: string, currentFolderId: string|null }
 * currentFolderId viaja junto pra o drop-target poder comparar contra o
 * proprio destino e dar no-op sem request quando a pasta nao mudou (ex.:
 * soltar de volta na mesma pasta, ou soltar em "sem pasta" ja sem pasta).
 */
export const CONVERSATION_MOVE_MIME = 'application/x-aawz-conversation-move'

// Escreve o payload de move no dataTransfer nativo. No-op quando o dataTransfer
// ou o conversationId está ausente (defensivo — nunca lança durante o
// drag-start).
export function writeConversationMovePayload(
  dataTransfer,
  { conversationId, currentFolderId = null } = {}
) {
  if (!dataTransfer) return
  if (conversationId == null || conversationId === '') return
  const payload = {
    conversationId: String(conversationId),
    currentFolderId: currentFolderId != null ? String(currentFolderId) : null,
  }
  try {
    dataTransfer.setData(CONVERSATION_MOVE_MIME, JSON.stringify(payload))
  } catch (e) {
    // Alguns browsers/jsdom lançam em chaves MIME incomuns no meio do drag —
    // degrada silenciosamente (o move só não dispara) em vez de quebrar o drag.
  }
}

// Lê + parseia o payload de move do dataTransfer de um evento de drop. Retorna
// null quando não há payload ou ele está malformado (para o chamador dar no-op).
export function readConversationMovePayload(dataTransfer) {
  if (!dataTransfer) return null
  let raw = null
  try {
    raw = dataTransfer.getData(CONVERSATION_MOVE_MIME)
  } catch (e) {
    return null
  }
  if (!raw) return null
  let parsed = null
  try {
    parsed = JSON.parse(raw)
  } catch (e) {
    return null
  }
  if (!parsed || !parsed.conversationId) return null
  return {
    conversationId: String(parsed.conversationId),
    currentFolderId:
      parsed.currentFolderId != null ? String(parsed.currentFolderId) : null,
  }
}
